<script setup lang="ts">
import ChatContainer from './ChatContainer.vue'

const open = defineModel<boolean>()
const props = defineProps<{ workOrderNumber?: string }>()
const emit = defineEmits(['closed'])

const handleClosed = () => {
  emit('closed')
}
</script>

<template>
  <el-dialog
    v-model="open"
    :width="800"
    :title="`${props.workOrderNumber} Work Order's chat`"
    :show-close="false"
    align-center
    @closed="handleClosed"
  >
    <ChatContainer v-if="props.workOrderNumber" :work-order-number="props.workOrderNumber" />
  </el-dialog>
</template>
